import { useState, useEffect } from 'react';

//Custom Hook para calcular la posición TOP y LEFT en realación al contenedor de referencia.
const useRefCalculator = (containerRef, topElement = 0, leftElement = 0) => {

    const [elementPosition, setElementPosition] = useState({ top: 0, left: 0 }); //Estado para actualizar la posición del elemento.

    useEffect(() => { //Se ejecuta cada vez que el cambie la referencia, y las posiciones Top y Left.
        const handleResize = () => { //Función para calcular la nueva posición top y left.

            if (containerRef.current) {
                //se utiliza getBoundingClientRect para obtener lo posición y tamaño
                //del contenedor containerRef.
                const rect = containerRef.current.getBoundingClientRect();
                const top = rect.top  + topElement;
                const left = rect.left + leftElement;
                setElementPosition({ top, left });
            }
        };

        handleResize(); // Para que se ajuste inicialmente.

        //Se agrega un listener de evento de cambio de tamaño al window.
        //Cuando se detecta un cambio en el tamaño de la ventana se llama a la función handleResize.
        window.addEventListener("resize", handleResize);
        
        return () => { //Cuándo el componente se desmonta se elimina el listener del evento.  
            window.removeEventListener("resize", handleResize);
        };

    }, [containerRef, topElement, leftElement]);

    return elementPosition; //Retorna las nuevas posiciones Top y Left en función a la referencia.

};

export default useRefCalculator;
